import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { socialConnectionsApi } from '@/services/social-connections-api';

export default function OAuthCallbackPage() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get('code');
    const state = params.get('state');
    const platform = window.location.pathname.split('/')[2];

    if (code && state && platform) {
      socialConnectionsApi.handleOAuthCallback(platform, code, state)
        .then(() => {
          window.opener.postMessage({ type: 'oauth_success' }, window.location.origin);
          window.close();
        })
        .catch(err => {
          window.opener.postMessage({ type: 'oauth_error', message: err.message }, window.location.origin);
          window.close();
        });
    } else {
      window.opener.postMessage({ type: 'oauth_error', message: 'Invalid callback parameters.' }, window.location.origin);
      window.close();
    }
  }, [location, navigate]);

  return <div>Processing...</div>;
}
